<template>
    <v-footer
        dark
        height="auto"
    >

        <v-card
            flat
            color="primary"
            width="100%"
        >
            <v-card-actions>
                <v-layout wrap>
                    <v-flex shrink>
                        &copy;2019
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex shrink>
                        <a class="white--text" @click.prevent.stop="$store.commit('setLegalNotice', true)">{{__('labels.legal_notice')}}</a> |
                        <a class="white--text" @click.prevent.stop="$store.commit('setPrivacyPolicy', true)">{{__('labels.privacy_policy')}}</a>
<!--                        <a class="white&#45;&#45;text" @click.prevent.stop="$store.commit('setTerms', true)">AGB</a>-->
                        <s-legal-notice :legal-notice="company.legalNotice" style="display: inline-block"></s-legal-notice>
                        <s-privacy-policy :privacy-policy="company.privacyPolicy" style="display: inline-block"></s-privacy-policy>
<!--                        <s-terms :organizer="organizer" style="display: inline-block"></s-terms>-->
                    </v-flex>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-footer>
</template>

<script>
    export default {
        name: "Footer",
        props: {
            company: Object
        },
    }
</script>

<style scoped>

</style>
